export default __webpack_public_path__ + "static/media/1.0aaa5563.png";